import styled from 'styled-components';

const FeedbackStyle = styled.div`
	--feedbackTextGap: var(--sp3x);
	--feedbackBannerGap: var(--sp2x);
	--feedbackBtnSize: var(--sp8x);

	display: flex;
	justify-content: flex-end;
	margin-top: calc(var(--contMarginV) / -4);

	.feedback-flex-block {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: var(--feedbackTextGap);
	}

	.buttons-block {
		display: flex;
		gap: var(--feedbackBannerGap);
	}

	svg {
		width: var(--feedbackBtnSize);
		height: var(--feedbackBtnSize);
		cursor: pointer;

		circle {
			transition: fill var(--trTime) ease-out;
		}

		@media (hover: hover) {
			&:hover {
				circle {
					fill: var(--secondaryColor3);
				}
			}
		}

		&.active {
			circle {
				fill: var(--secondaryColor4);
			}
		}

		&.disable {
			cursor: default;
			pointer-events: none;
		}
	}

	/* //! 1920 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--feedbackTextGap: var(--sp2-5x);
		--feedbackBannerGap: var(--sp2x);
		--feedbackBtnSize: var(--sp7x);
	}

	/* //! 1510 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--feedbackTextGap: var(--sp2-5x);
		--feedbackBannerGap: var(--sp2x);
		--feedbackBtnSize: var(--sp7x);
	}

	/* //! 1440 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--feedbackTextGap: var(--sp2-5x);
		--feedbackBannerGap: var(--sp1-5x);
		--feedbackBtnSize: var(--sp6x);
	}

	/* //! 1280 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--feedbackTextGap: var(--sp2-5x);
		--feedbackBannerGap: var(--sp1-5x);
		--feedbackBtnSize: var(--sp6x);
	}

	/* //! 1024 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--feedbackTextGap: var(--sp2x);
		--feedbackBannerGap: var(--sp1x);
		--feedbackBtnSize: var(--sp5x);
	}

	/* //! 768 */
	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--feedbackTextGap: var(--sp2x);
		--feedbackBannerGap: var(--sp1x);
		--feedbackBtnSize: var(--sp5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--feedbackTextGap: var(--sp2x);
		--feedbackBannerGap: var(--sp1x);
		--feedbackBtnSize: var(--sp8x);

		.feedback-flex-block {
			width: 100%;
			justify-content: space-between;
		}
	}
`;

export default FeedbackStyle;
